import { Box } from '@mui/material';
import React from 'react';
import { upgradeToolBarPreferences } from '../config/plotPreferences';
import { ToolBarPreferences } from '../config/plotTypes';
import {
  RefreshIntervalSelector,
  RefreshIntervalSelectorProps,
} from './RefreshIntervalSelector';
import { ReloadButton, ReloadButtonProps } from './ReloadButton';
import { TimeRangePillSet, TimeRangePillSetProps } from './TimeRangePillSet';

export type ToolBarProps = TimeRangePillSetProps &
  ReloadButtonProps &
  RefreshIntervalSelectorProps & {
    hide: boolean;
    useTimeRangePills: boolean;
    useReloadButton: boolean;
    useRefreshIntervalSelector: boolean;
  };

export const ToolBar: React.FC<ToolBarProps> = ({
  hide,
  useTimeRangePills,
  useReloadButton,
  useRefreshIntervalSelector,
  ...props
}) => {
  const resolvedToolBarPrefs = upgradeToolBarPreferences({
    hide,
    useTimeRangePills,
    useReloadButton,
    useRefreshIntervalSelector,
    selectedRefreshInterval: props.value,
    refreshIntervalOptions: props.options,
    timeRangeOptions: props.units,
  } as ToolBarPreferences);

  if (resolvedToolBarPrefs.hide) return null;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      flexWrap="wrap"
      gap={1}
      mt={1}
      px={1.5}
      py={1}
      sx={{
        borderRadius: 1,
        border: '1px solid',
        borderColor: 'divider',
        boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
        bgcolor: 'background.paper',
        flexShrink: 0,
      }}
    >
      {resolvedToolBarPrefs.useTimeRangePills && (
        <TimeRangePillSet
          initialSelected={props.initialSelected}
          units={resolvedToolBarPrefs.timeRangeOptions}
          onSelect={props.onSelect}
        />
      )}
      <Box display="flex" gap={1} alignItems="center">
        {resolvedToolBarPrefs.useReloadButton && (
          <ReloadButton onReload={props.onReload} />
        )}
        {resolvedToolBarPrefs.useRefreshIntervalSelector && (
          <RefreshIntervalSelector
            value={resolvedToolBarPrefs.selectedRefreshInterval}
            options={resolvedToolBarPrefs.refreshIntervalOptions}
            onIntervalChange={props.onIntervalChange}
            onStop={props.onStop}
          />
        )}
      </Box>
    </Box>
  );
};
